import { combineReducers } from "@reduxjs/toolkit";
import advanced from "./advanced";
import fibo from "./fibo";
import icons from "./icons";
import metadata from "./metadata";
import transient from "./transient";
import ui from "./ui";

export const document = combineReducers({
  fibonaccis: fibo.reducer,
  metadata: metadata.reducer,
  advanced: advanced.reducer,
});
const rootReducer = combineReducers({
  document: document,
  uiState: ui.reducer,
  icons: icons.reducer,
  transient: transient.reducer,
});

export default rootReducer;
